import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import * as StationActions from './station.actions';
import { StationLongDto, StationV11Service } from '@api/rest';

@Injectable()
export class StationEffects {
  private actions$ = inject(Actions);
  private stationHttp = inject(StationV11Service);


  loadStations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StationActions.loadStations),
      switchMap(() => this.stationHttp.restV11StationGet(true, true)
        .pipe(
          map((stations: StationLongDto[]) => StationActions.loadStationsSuccess({ stations })),
          catchError(error => of(StationActions.loadStationsFailure({ error })))
        )
      )
    );
  });

  setSelected: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType('@ngrx/router-store/navigated'),
      map((action: any) => action.payload.event.url.split('/')),
      filter(routes => routes.includes('station')),
      map(routes => routes[ routes.findIndex(route => route === 'station') + 1 ]),
      map(id => StationActions.setSelectedStation({ id }))
    )
  );

  setSelectedSubstation: Observable<any> = createEffect(() =>
  this.actions$.pipe(
    ofType('@ngrx/router-store/navigated'),
    map((action: any) => action.payload.event.url.split('/')),
    filter(routes => routes.includes('substation')),
    map(routes => routes[ routes.findIndex(route => route === 'substation') + 1]),
    map(id => StationActions.setSelectedSubstation({ id }))
  )
);

  getStation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StationActions.getStation),
      switchMap(payload => this.stationHttp.restV11StationIdGet(payload.id)
        .pipe(
          map(station => StationActions.getStationSuccess({ station })),
          catchError(error => of(StationActions.getStationFailure({ error })))
        )
      )
    );
  });

}
